import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.css']
})
export class CountDownComponent implements OnInit {

  @Input() public fechaEvento: string;
  public fechaLimite: Date;
  public now: Date;

  public _second = 1000;
  public _minute = this._second * 60;
  public _hour = this._minute * 60;
  public _day = this._hour * 24;
  public timer;

  public seconds: number;
  public minutes: number;
  public hours: number;
  public days: number;

  public distance: number;

  constructor() {}

  ngOnInit() {
    this.fechaLimite = new Date(this.fechaEvento);

    this.timer = setInterval(() => {
      this.now = new Date();

      this.DiffDays(this.now, this.fechaLimite);
      //console.log("dias: " + this.days, ", horas: " + this.hours, ", mins: " + this.minutes, ", segs: " + this.seconds);
    }, 1000)    

  }

  DiffDays(a, b)
  {
    this.distance = this.fechaLimite.getTime() - this.now.getTime();

    if (this.distance <= 0) {
      //console.log(this.distance);
      clearInterval(this.timer);
    }

    this.days = Math.floor(this.distance / this._day);
    this.hours = Math.floor((this.distance % this._day) / this._hour);
    this.minutes = Math.floor((this.distance % this._hour) / this._minute);
    this.seconds = Math.floor((this.distance % this._minute) / this._second);
  }
}
